import { House } from "lucide-react";
import { siteData } from "@/lib/aht/pageData";
import { imageUrl } from "@/components/aht/Img";
import { useImageAvailable } from "@/lib/aht/hooks";

// Brand logo from /public/images/logos. Falls back to a display-font wordmark.
export function Logo({ kind = "team", onDark = false, height = 24, testId }) {
  const { assets, ui, agent } = siteData;
  const src =
    kind === "team"
      ? onDark
        ? assets.logoOnDark
        : assets.logoOnLight
      : onDark
        ? assets.expOnDark
        : assets.expOnLight;
  const alt = kind === "team" ? ui.alt.logoTeam : ui.alt.logoBrokerage;
  const ok = useImageAvailable(imageUrl(src));

  if (ok) {
    return <img src={imageUrl(src)} alt={alt} style={{ height }} className="block w-auto" data-testid={testId} />;
  }

  const color = onDark ? "var(--paper)" : "var(--ink)";
  return (
    <span
      className="inline-flex items-center gap-2 whitespace-nowrap font-display font-bold"
      style={{ height, fontSize: Math.round(height * 0.66), color, letterSpacing: "-0.01em", opacity: ok === null ? 0.001 : 1 }}
      role="img"
      aria-label={alt}
      data-testid={testId}
    >
      {kind === "team" && <House aria-hidden="true" size={Math.round(height * 0.9)} strokeWidth={2.25} style={{ color: "var(--logo-gold)" }} />}
      <span aria-hidden="true">{kind === "team" ? agent.team : agent.brokerage}</span>
    </span>
  );
}
